/** Legacy `/org/…` prefixes → canonical module paths. */
export const LEGACY_ORG_MODULE_REDIRECTS: { fromPrefix: string; toPrefix: string }[] = [
  { fromPrefix: '/org/lead-gen', toPrefix: '/lead-gen' },
  { fromPrefix: '/org/marketing', toPrefix: '/marketing' },
  { fromPrefix: '/org/procurement', toPrefix: '/procurement' },
  { fromPrefix: '/org/warehouse', toPrefix: '/warehouse' },
  { fromPrefix: '/org/finance', toPrefix: '/finance' },
  { fromPrefix: '/org/projects', toPrefix: '/projects' },
  { fromPrefix: '/org/social', toPrefix: '/social' },
  { fromPrefix: '/org/crm', toPrefix: '/crm' },
  { fromPrefix: '/org/desk', toPrefix: '/desk' },
  { fromPrefix: '/org/hr', toPrefix: '/hr' },
];

/** Legacy POS back-office paths that moved from `/org/*` to `/pos/*`. */
export const LEGACY_ORG_POS_REDIRECTS: { fromPrefix: string; toPrefix: string }[] = [
  { fromPrefix: '/org/inventory/ledger', toPrefix: '/pos/inventory/ledger' },
  { fromPrefix: '/org/store-products', toPrefix: '/pos/store-products' },
  { fromPrefix: '/org/product-alerts', toPrefix: '/pos/product-alerts' },
  { fromPrefix: '/org/tax-rules', toPrefix: '/pos/tax-rules' },
  { fromPrefix: '/org/inventory', toPrefix: '/pos/inventory' },
  { fromPrefix: '/org/invoices', toPrefix: '/pos/invoices' },
  { fromPrefix: '/org/customers', toPrefix: '/pos/customers' },
  { fromPrefix: '/org/categories', toPrefix: '/pos/categories' },
  { fromPrefix: '/org/discounts', toPrefix: '/pos/discounts' },
  { fromPrefix: '/org/suppliers', toPrefix: '/pos/suppliers' },
  { fromPrefix: '/org/products', toPrefix: '/pos/products' },
  { fromPrefix: '/org/reports', toPrefix: '/pos/reports' },
  { fromPrefix: '/org/stores', toPrefix: '/pos/stores' },
  { fromPrefix: '/org/brands', toPrefix: '/pos/brands' },
  { fromPrefix: '/org/units', toPrefix: '/pos/units' },
  { fromPrefix: '/org/taxes', toPrefix: '/pos/tax-rules' },
];

export const ALL_LEGACY_ORG_REDIRECTS = [
  ...LEGACY_ORG_MODULE_REDIRECTS,
  ...LEGACY_ORG_POS_REDIRECTS,
];
